module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-photo-data-785ad04cbc31cdcca5f7abf27d38b801.png";